{
  "version": 1,
  "asset_id": "2b402eb9-b3e9-40da-9934-b5fa972da6e0",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/2b402eb9-b3e9-40da-9934-b5fa972da6e0/hernando-galvalume-metal-roof-aerial-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/2b402eb9-b3e9-40da-9934-b5fa972da6e0/hernando-galvalume-metal-roof-aerial-480w.avif",
  "original_filename": "hernando-galvalume-metal-roof-aerial-480w.avif",
  "size": 13775,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
